import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/tailwind-light/theme.css';
import 'primeicons/primeicons.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import React from 'react';
import RoutesIndex from './routes/RoutesIndex';
import { ToastContainer } from 'react-toastify';

function App() {

  return (
      <div className=' w-screen hont'>
        <ToastContainer theme="light" />
        <RoutesIndex />
      </div>
  );
}

export default App;
